import { render, staticRenderFns } from "./gallery_indexTw.vue?vue&type=template&id=bc8d755e&scoped=true&"
import script from "./gallery_indexTw.vue?vue&type=script&lang=js&"
export * from "./gallery_indexTw.vue?vue&type=script&lang=js&"
import style0 from "./gallery_indexTw.vue?vue&type=style&index=0&id=bc8d755e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d755e",
  null
  
)

export default component.exports